export const cookies = {
  get(key: string): string | undefined {
    return document.cookie
      .split(";")
      .reduce<Record<string, string>>((acc, cookie) => {
        const [cookieKey, value] = cookie.trim().split("=");
        acc[cookieKey] = value;
        return acc;
      }, {})[key];
  },
};
